import { Schema } from '../../../utils/form';
import { FormattedMessage } from 'react-intl';

export default Schema.object({
  idIntegracao: Schema.string().label(<FormattedMessage id="idIntegracao" />),
  nome: Schema.string().label(<FormattedMessage id="nome" />),
  nivelCargo: Schema.string().label(<FormattedMessage id="tipoCargo" />),
  criticidade: Schema.string().label(<FormattedMessage id="criticidade"/>),
  descricao: Schema.string().label(<FormattedMessage id="descricao"/>),
});
